import React, {useEffect, useState} from "react"
import {Card, Switch} from "@blueprintjs/core"
import {useDispatch, useSelector} from "react-redux"
import handleBooleanChange from "../../../core/utils/handleChangehelpers"
import {RefDbDataContext} from "../../models/displayDataContext"
import {
    classesSelector,
    getMultiContext,
    getRefDbDataContext,
    metabolitesSelector,
} from "../../redux/refdb.selector"

import {
    IMultiSelectItemState,
    MultiSelectString,
} from "../../../core/components/MultiSelectString"
import {
    loadClassesAction,
    loadMetabolitesAction,
    setDisplayDataContextAction,
    setMultipleContextAction,
} from "../../redux/refdb.actions"
import useComponentWillMount from "../../../core/utils/componentUtils"
import {MultiSelectObject} from "../../../core/components/MultiSelectObject"

export interface DisplayOptionsCardProps {
    subset: number
}

const DisplayOptionsCardInternal: React.FC<DisplayOptionsCardProps> = (
    props
) => {
    const dispatch = useDispatch()
    const contextData = useSelector(getMultiContext)
    const contextSingleData = useSelector(getRefDbDataContext)
    const [context, setContext] = useState<RefDbDataContext>(
        contextData[props.subset]
    )

    useComponentWillMount(() => {
        dispatch(loadClassesAction(true))
        dispatch(loadMetabolitesAction(true))
    })

    const classes = useSelector(classesSelector)
    const metabolites = useSelector(metabolitesSelector)

    useEffect(() => {
        console.log("Dispatch context to redux...")
        dispatch(setMultipleContextAction(context))
    }, [context])

    const handleSelect = (e: IMultiSelectItemState) => {
        setContext({
            ...context,
            [e.name]: {value: e.selected, enable: context[e.name].enable},
        })
    }

    const updateSwitch = (name: string, selected: any) => {
        const newContext = {
            ...context,
            [name]: {value: context[name].value, enable: selected},
        }

        setContext(newContext)
    }

    const updateBoolean = (name, selected) => {
        const newContext = {
            ...contextSingleData,
            [name]: selected,
        }
        dispatch(setDisplayDataContextAction(newContext))
    }

    return (
        <Card>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={context.classes.enable}
                    labelElement="Restrict class"
                    onChange={handleBooleanChange((value) =>
                        updateSwitch("classes", value)
                    )}
                />

                <MultiSelectString
                    disabled={!context.classes.enable}
                    selected={context.classes.value}
                    items={classes || []}
                    handleSelect={handleSelect}
                    name="classes"
                />
            </div>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={context.metabolites.enable}
                    labelElement="Restrict metabolites"
                    onChange={handleBooleanChange((value) =>
                        updateSwitch("metabolites", value)
                    )}
                />

                <MultiSelectObject
                    disabled={!context.metabolites.enable}
                    selected={context.metabolites.value}
                    items={metabolites || []}
                    handleSelect={handleSelect}
                    name="metabolites"
                />
            </div>
            <div className="CardRow">
                <Switch
                    className="CardRowElement"
                    checked={contextSingleData.showHmdbId}
                    labelElement="Show HMDB IDs"
                    onChange={handleBooleanChange((value) =>
                        updateBoolean("showHmdbId", value)
                    )}
                />
            </div>
        </Card>
    )
}

export default DisplayOptionsCardInternal
